import angular from 'angular';

/**
 *
 */ (function() {
    'use strict';
    angular.module('app.core').factory('CompanyRelationFilter', CompanyRelationFilterData);

    CompanyRelationFilterData.$inject = ['KISS_SELLER'];

    /* @ngInject */
    function CompanyRelationFilterData(KISS_SELLER) {
        CompanyRelationFilter.prototype = {
            build: build,
            buildEmpty: buildEmpty,
            preparBeforeSearch: preparBeforeSearch,
            setPage: setPage,
            setPageSize: setPageSize,
            setSort: setSort,
            resetSort: resetSort
        };

        function CompanyRelationFilter(companyRelationFilterData) {
            if (!companyRelationFilterData) {
                this.buildEmpty();
            } else {
                this.build(companyRelationFilterData);
            }
        }

        return CompanyRelationFilter;

        /////////////////////

        function buildEmpty() {
            this.seller = null;
            this.principal = null;
            this.country = null;
            this.status = 'ALL';
            this.ladType = 'ALL';
            this.dematMode = 'ALL';
            this.onlyValidated = null;
            this.onlyAccepted = null;
            this.pageCriteria = {
                pageSize: KISS_SELLER.relation.pagination.defaultPageSize,
                page: KISS_SELLER.relation.pagination.defaultPage,
                sorts: KISS_SELLER.relation.pagination.defaultSort
            };
        }

        function build(companyRelationFilter) {
            this.seller = companyRelationFilter.seller || null;
            this.principal = companyRelationFilter.principal || null;
            this.country = companyRelationFilter.country || null;
            this.status = companyRelationFilter.status || null;
            this.ladType = companyRelationFilter.ladType || null;
            this.dematMode = companyRelationFilter.dematMode || null;
            this.onlyValidated = companyRelationFilter.onlyValidated || null;
            this.onlyAccepted = companyRelationFilter.onlyAccepted || null;
            this.pageCriteria = {
                pageSize: companyRelationFilter.pageSize || KISS_SELLER.relation.pagination.defaultPageSize,
                page: companyRelationFilter.page || KISS_SELLER.relation.pagination.defaultPage,
                sorts: _setSort(companyRelationFilter.sorts)
            };
        }

        function _setSort(sorts) {
            if (!sorts || sorts.length === 0) {
                return KISS_SELLER.relation.pagination.defaultSort;
            }
            return sorts;
        }

        /**
         *
         */
        function preparBeforeSearch() {
            var clone = new CompanyRelationFilter(this);
            clone.pageCriteria = this.pageCriteria;

            clone.principalId = this.principal ? this.principal.id : null;
            clone.sellerId = this.seller ? this.seller.legalEntity.id : null;
            clone.countryCode = this.country ? this.country.code : null;

            if (clone.ladType === 'ALL') {
                clone.ladType = null;
            }
            if (clone.dematMode === 'ALL') {
                clone.dematMode = null;
            }
            if (clone.status === 'ALL') {
                clone.status = null;
            }

            return clone;
        }

        /**
         * Indiquer la page
         */
        function setPage(page) {
            this.pageCriteria.page = page;
        }

        /**
         * Changement de pagination
         */
        function setPageSize(pageSize) {
            this.pageCriteria.pageSize = pageSize;
        }

        /**
         * Mise à jour du tri (tri sur une seule colonne)
         */
        function setSort(sorts) {
            this.pageCriteria.sorts = sorts;
        }

        /**
         * Lorsqu'on ne souhaite aucun tri
         */
        function resetSort() {
            this.pageCriteria.sorts = [];
        }
    }
})();
